<template>
	<div>
		<a-form-item label="" has-feedback class="mb-1">
			<a-select
				:defaultValue="!post.categoryAId ? 0 :  post.categoryAId"
				style="width: 100%;"
				@change="handleCategory(post, $event, 'A')"
			>
				<a-select-option :value="0">Seleccione</a-select-option>
				<a-select-option
					v-for="(category, key) in categoryA"
					:key="key"
					:value="category.id"
				>
					{{ category.code }}
				</a-select-option>
			</a-select>
		</a-form-item>
		<a-form-item label="" has-feedback class="mb-1">
			<a-select
				:defaultValue="!post.categoryBId ? 0 : post.categoryBId"
				style="width: 100%;"
				@change="handleCategory(post, $event, 'B')"
			>
				<a-select-option :value="0">Seleccione</a-select-option>
				<a-select-option
					v-for="(category, key) in categoryB"
					:key="key"
					:value="category.id"
				>
					{{ category.code }}
				</a-select-option>
			</a-select>
		</a-form-item>
	</div>
</template>

<script>
import * as ACTIONS from '@/store/actions'
import { mapActions } from 'vuex'

export default {
	name: 'PostCategories',
	props: {
		post: {
			type: Object,
			required: true,
		},
		categoryA: {
			type: Array,
			required: true,
		},
		categoryB: {
			type: Array,
			required: true,
		},
	},
	data: function() {
		return {
		}
	},
	methods: {
		...mapActions({
			updatePostCategory: ACTIONS.POST_CATEGORY.UPDATE,
		}),
		handleCategory(post, category, type) {
			let pepito = {}

			if (type === 'B') {
				pepito.postId = post.id
				pepito.postSubCategoryId = category
				pepito.postCategoryId = post.categoryAId
			} else if (type === 'A') {
				pepito.postId = post.id
				pepito.postCategoryId = category
				pepito.postSubCategoryId = post.categoryBId
			}

			if (post.ptpcId) {
				pepito.id = post.ptpcId
			}

			this.updatePostCategory(pepito)
				.then(res => {
					this.$notification.success('Post updated')
				})
				.catch(() => {
					this.$notification.error('Opss', 'Something went wrong')
				})
		},
	},
}
</script>

<style></style>
